export enum ActionButtonImages {
  DOWNLOAD = 'assets/img/icons/icon-download.svg',
  MAIL = 'assets/img/icons/icon-mail.svg'
}
